import { render, staticRenderFns } from "./GarageOverview.vue?vue&type=template&id=faa0d8d0"
import script from "./GarageOverview.vue?vue&type=script&lang=js"
export * from "./GarageOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports